<template>
    <span
        :class="['status-indicator', `status-indicator--${size}`, `status-indicator--${color}`]"
        :title="colorLabel"/>
</template>

<script>
    export default {
        name: 'StatusIndicator',
        props: {
            color: {
                type: String,
                required: true,
                validator: (value) => ['green', 'yellow', 'red', 'neutral'].includes(value),
            },
            size: {
                default: 'sm',
                type: String,
                validator: (value) => ['sm', 'lg'].includes(value),
            },
        },
        computed: {
            colorLabel() {
                const labels = {
                    green: 'OK',
                    neutral: 'Neutral',
                    red: 'Handlungsbedarf',
                    yellow: 'Achtung',
                };
                return labels[this.color] || this.color;
            },
        },
    }
</script>
